import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'kwo-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent implements OnInit {

	@Input() message: string;
	@Input() type: 'danger' | 'success' | 'warning' | 'info';

	constructor() {

	}

	ngOnInit(): void {

	}
}
